export default {
  ACTION_CANCELED: 'ACTION_CANCELED',
  AUDIO_NOT_EXISTS: 'AUDIO_NOT_EXISTS',
  AUDIO_RENDERER_ERROR: 'AUDIO_RENDERER_ERROR',
  AUTHENTICATION_REQUIRED: 'AUTHENTICATION_REQUIRED',
  BACKOFFICE_UNAVAILABLE: 'BACKOFFICE_UNAVAILABLE',
  BLACKOUT_CONTENT: 'BLACKOUT_CONTENT',
  CAPTCHA_BLANK: 'CAPTCHA_BLANK',
  CLIP_NOT_AVAILABLE: 'CLIP_NOT_AVAILABLE',
  DATE_INVALID_FORMAT: 'DATE_INVALID_FORMAT',
  DRM_GENERATE_MEDIA_KEYS_FAILED: 'DRM_GENERATE_MEDIA_KEYS_FAILED',
  EMBEDDING_NOT_ALLOWED: 'EMBEDDING_NOT_ALLOWED',
  EPG_NOT_AVAILABLE: 'EPG_NOT_AVAILABLE',
  GENERIC: 'GENERIC',
  GEOIP_FILTER_FAILED: 'GEOIP_FILTER_FAILED',
  GEOIP_EEA_FILTER_FAILED: 'GEOIP_EEA_FILTER_FAILED',
  GEOIP_FILTER_EU_AND_NOT_VERIFIED: 'GEOIP_FILTER_EU_AND_NOT_VERIFIED',
  GEOIP_FILTER_OUTSIDE_EU_AND_EEA: 'GEOIP_FILTER_OUTSIDE_EU_AND_EEA',
  ITEM_NOT_AVAILABLE: 'ITEM_NOT_AVAILABLE',
  LICENSE_RENEW_FAILED: 'LICENSE_RENEW_FAILED',
  LOW_FPS: 'LOW_FPS',
  MEDIA_TYPE_NOT_SUPPORTED: 'MEDIA_TYPE_NOT_SUPPORTED',
  NETWORK_ERROR: 'NETWORK_ERROR',
  NO_SUPPORTED_RENDERER: 'NO_SUPPORTED_RENDERER',
  PASSWORD_INVALID_LENGTH: 'PASSWORD_INVALID_LENGTH',
  PASSWORD_REPEAT_INVALID: 'PASSWORD_REPEAT_INVALID',
  PASSWORD_SAME_AS_CURRENT: 'PASSWORD_SAME_AS_CURRENT',
  PIN_NEW_REPEAT_INVALID: 'PIN_NEW_REPEAT_INVALID',
  PLAYER_LOAD_MOVIE_FAILED: 'PLAYER_LOAD_MOVIE_FAILED',
  PLAYER_LOAD_LICENSE_FAILED: 'PLAYER_LOAD_LICENSE_FAILED',
  PLAYER_LOAD_PLAYLIST_FAILED: 'PLAYER_LOAD_PLAYLIST_FAILED',
  PLAYER_TRANSFER_DEGRADATION: 'PLAYER_TRANSFER_DEGRADATION',
  SAFARI_NOT_SUPPORTED: 'SAFARI_NOT_SUPPORTED',
  SUBSCRIBER_INVALID_PIN: 'SUBSCRIBER_INVALID_PIN',
  SUBSCRIBER_IS_SUSPENDED: 'SUBSCRIBER_IS_SUSPENDED',
  SUBSCRIBER_MSISDN_INVALID: 'SUBSCRIBER_MSISDN_INVALID',
  SUBSCRIBER_NOT_VERIFIED: 'SUBSCRIBER_NOT_VERIFIED',
  TRANSFER_DEGRADATION: 'TRANSFER_DEGRADATION',
  TRACKING_SCRIPT_ERROR: 'TRACKING_SCRIPT_ERROR',
  VIDEO_NOT_EXISTS: 'VIDEO_NOT_EXISTS',
  VIDEO_SESSION_LIMIT_EXCEEDED: 'VIDEO_SESSION_LIMIT_EXCEEDED',
  VIDEO_SESSION_EXPIRED: 'VIDEO_SESSION_EXPIRED',
  VIDEO_360_NOT_SUPPORTED: 'VIDEO_360_NOT_SUPPORTED',
  WATCHING_TOO_LONG: 'WATCHING_TOO_LONG',
};
